export const QuizSvg = ({ props, active }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_20994_206135)">
        <mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={1}
          y={1}
          width={22}
          height={23}
        >
          <path d="M1 1.5h22v22H1v-22z" fill={active ? '#FF6A00' : '#fff'} />
        </mask>
        <g mask="url(#a)">
          <path
            d="M12 9.45v-.411c0-.447.266-.83.65-1.055.383-.224.64-.638.64-1.113M13.29 6.871a1.29 1.29 0 00-2.58 0"
            stroke={active ? '#FF6A00' : '#fff'}
            strokeWidth={1.34277}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.645 12.027a.645.645 0 11-1.29 0 .645.645 0 011.29 0z"
            fill={active ? '#FF6A00' : '#fff'}
          />
          <path
            d="M15.438 17.184H8.561v1.804c0 .712.578 1.29 1.29 1.29h4.296c.712 0 1.29-.578 1.29-1.29v-1.804zM5.557 8.59a6.4 6.4 0 001.417 4.025 7.285 7.285 0 011.59 4.569h6.876c0-1.66.55-3.276 1.59-4.569a6.4 6.4 0 001.417-4.025M18.447 8.59a6.445 6.445 0 00-12.89 0"
            stroke={active ? '#FF6A00' : '#fff'}
            strokeWidth={1.34277}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.148 20.277H9.852v1.29c0 .711.577 1.288 1.289 1.288h1.718c.712 0 1.29-.577 1.29-1.289v-1.289zM21.066 8.59h1.29M2.934 8.59h-1.29M20.521 5.503l1.212-.441M3.48 11.676l-1.21.441M20.521 11.676l1.212.441M3.48 5.503l-1.21-.441"
            stroke={active ? '#FF6A00' : '#fff'}
            strokeWidth={1.34277}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_20994_206135">
          <path
            fill={active ? '#FF6A00' : '#fff'}
            transform="translate(1 1.5)"
            d="M0 0H22V22H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
